import React, { useState } from "react";

function renderBody(body) {
  if (!body) return null;
  return body.split("\n\n").map((chunk, i) => {
    const t = chunk.trim();
    if (!t) return null;
    if (t.startsWith("### ")) {
      return <h4 key={i} style={h4}>{t.replace(/^###\s*/, "")}</h4>;
    }
    return <p key={i} style={pStyle}>{t}</p>;
  });
}

function SeoSection({ s }) {
  return (
    <div style={block}>
      {s.heading && <h3 style={h3}>{s.heading}</h3>}
      {s.bullets
        ? <ul style={ul}>{s.bullets.map((b, j) => <li key={j} style={li}>{b}</li>)}</ul>
        : renderBody(s.body)
      }
    </div>
  );
}

export default function SeoExpandable({ title, sections, faqs }) {
  const [expanded, setExpanded] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const previewSections = sections.slice(0, 2);
  const moreSections = sections.slice(2);

  return (
    <section style={wrap}>
      <div style={seoLabel}>📚 EDUCATIONAL CONTENT</div>
      <div style={inner}>
        <h2 style={h2}>{title}</h2>

        {previewSections.map((s, i) => <SeoSection key={i} s={s} />)}

        <div style={{ overflow: "hidden", maxHeight: expanded ? "99999px" : 0, transition: "max-height .4s ease" }}>
          {moreSections.map((s, i) => <SeoSection key={i} s={s} />)}

          {faqs && faqs.length > 0 && (
            <div style={faqWrap}>
              <h3 style={faqTitle}>Frequently Asked Questions</h3>
              {faqs.map((faq, i) => (
                <div key={i} style={faqItem}>
                  <button type="button" style={faqQ} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                    <span>{faq.q}</span>
                    <span style={faqIcon}>{openFaq === i ? "−" : "+"}</span>
                  </button>
                  {openFaq === i && <p style={faqA}>{faq.a}</p>}
                </div>
              ))}
            </div>
          )}
        </div>

        <button type="button" style={toggleBtn} onClick={() => setExpanded(v => !v)}>
          {expanded ? "View Less ▲" : "View More ▼"}
        </button>
      </div>
    </section>
  );
}

const wrap      = { background: "#fff", borderTop: "4px solid #312e81", padding: "32px 0" };
const seoLabel  = { background: "#312e81", color: "#fff", fontSize: 11, fontWeight: 900, letterSpacing: "0.12em", padding: "8px 24px", textAlign: "center" };
const inner     = { maxWidth: 1100, margin: "0 auto", padding: "24px 24px 0" };
const h2        = { fontSize: "clamp(20px,3vw,26px)", fontWeight: 900, color: "#0f172a", margin: "0 0 20px", lineHeight: 1.3 };
const h3        = { fontSize: 16, fontWeight: 800, color: "#1e293b", margin: "0 0 10px" };
const h4        = { fontSize: 14, fontWeight: 800, color: "#312e81", margin: "14px 0 6px" };
const pStyle    = { fontSize: 14, color: "#475569", lineHeight: 1.8, margin: "0 0 10px" };
const block     = { marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid #e2e8f0" };
const ul        = { paddingLeft: 20, margin: "0 0 6px" };
const li        = { fontSize: 14, color: "#475569", lineHeight: 1.8, marginBottom: 4 };
const toggleBtn = { marginTop: 20, padding: "10px 28px", border: "2px solid #312e81", borderRadius: 8, background: "#fff", color: "#312e81", fontWeight: 800, fontSize: 14, cursor: "pointer" };
const faqWrap   = { marginTop: 28 };
const faqTitle  = { fontSize: 18, fontWeight: 900, color: "#0f172a", margin: "0 0 14px" };
const faqItem   = { borderBottom: "1px solid #e2e8f0" };
const faqQ      = { width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "13px 0", border: 0, background: "transparent", textAlign: "left", fontWeight: 700, fontSize: 14, color: "#0f172a", cursor: "pointer", gap: 12 };
const faqIcon   = { fontSize: 18, fontWeight: 900, color: "#f97316", flexShrink: 0 };
const faqA      = { fontSize: 13, color: "#475569", lineHeight: 1.75, paddingBottom: 12, margin: 0 };
